// @flow
const _Http = {
  execute: function (url: string, params: any, method: string = 'POST', headers?: Map<string, string>): Promise<any> {
    let request = new XMLHttpRequest();
    return new Promise((resolve, reject) => {
      request.onreadystatechange = function () {
        if (request.readyState === 4) {
          if (request.status === 200) {
            let jsonResponse;
            try{
              jsonResponse = JSON.parse(request.responseText);
            }catch (e) {
              // respuesta 200 que no es json (por ejemplo el index.html de un fallback de rutas)
              reject(e);
              return;
            }
            resolve(jsonResponse);
          } else {
            reject(request.responseText);
          }
        }
      };
      request.open(method, url);
      if (headers) {
        headers.forEach((value, key) => {
          request.setRequestHeader(key, value);
        });
      }
      request.send(params);
    });
  }
};

export {_Http as Http};
